// extracted by mini-css-extract-plugin
var _1 = "NewPostHistoryView-module__controlBar--uc5vj";
export { _1 as "controlBar" }
